@if (get(subcategoryLinksRow, 'subcategory_links.subcategory_reference.category_pages')) {
    <section class="subcategory-links p-0">
        <div>
            <div [class.gray-bg]="get(subcategoryLinksRow, 'subcategory_links.gray_background')">
                <div class="container padding-container">
                    <h2 class="row-header">
                        {{ subcategoryLinksRow.subcategory_links.header }}
                    </h2>
                    <div class="subcategory-grid" [style.--grid-columns]="get(subcategoryLinksRow, 'subcategory_links.columns_number')">
                        @for (item of get(subcategoryLinksRow, 'subcategory_links.subcategory_reference.category_pages', []); track item) {
                            @let page = get(item, 'page[0]');
                            <div>
                                <div class="subcategory-link-container fx-col">
                                    @if (get(page, 'subcategory_partial.subcategory_image.subcategory_image_url', '')) {
                                        <a
                                            class="subcategory-card-container fx-col fx-wrap"
                                            [style.--gradient-color-1]="item.background_theme.colors[0]"
                                            [style.--gradient-color-2]="item.background_theme.colors[1]"
                                            [style.--gradient-color-3]="item.background_theme.colors[2]"
                                            [routerLink]="getLinkUrl(page?.routerLink)"
                                            [attr.aria-label]="page?.subcategory_partial?.subcategory_header"
                                        >
                                            <img
                                                [src]="getWebpImg(get(page, 'subcategory_partial.subcategory_image.subcategory_image_url', ''))"
                                                alt=""
                                            />
                                            @if (get(page, 'subcategory_partial.logo_image.subcategory_logo_url', '')) {
                                                <img
                                                    class="card-logo"
                                                    [src]="getWebpImg(get(page, 'subcategory_partial.logo_image.subcategory_logo_url', ''))"
                                                    alt=""
                                                />
                                            }
                                        </a>
                                    }
                                    @if (get(page, 'routerLink', '')) {
                                        <!-- The image card is the tab stop when it exists; otherwise this link is -->
                                        <a
                                            [attr.tabindex]="get(page, 'subcategory_partial.subcategory_image.subcategory_image_url', '') ? -1 : null"
                                            [routerLink]="getLinkUrl(page?.routerLink)"
                                            class="subcategory-link-text d-flex flex-row align-items-center"
                                        >
                                            <span>
                                                {{ page?.subcategory_partial?.subcategory_header }}
                                            </span>
                                            <mat-icon>chevron_right</mat-icon>
                                        </a>
                                    }
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    </section>
}
